// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"ChapterSwitchButtons_buttonWrapper__PyRfr","button":"ChapterSwitchButtons_button__D3Kge","buttonDisabled":"ChapterSwitchButtons_buttonDisabled__iqAV7"};